import { FlowWay, getCashFlowWay } from 'components/common-form/sidePanel/status/cashFlowWayUtils';
import { connect } from 'react-redux';
import type { SolveResultFormat } from 'state/quotes/results/result.model';
import {
  getFormQuoteDetails,
  getFormQuoteId,
  getFormQuoteResult,
  getQuoteCurrency,
  getQuotePriceInCurrency,
  getQuotePriceInPercent,
  getQuotePricerToBookingInvertedFlow,
  getQuoteRemunerationMode,
  getQuoteSolvingMode,
  getSidePanelTradeWayOrDefault,
} from 'state/selectors';
import { getTradeInfosByWorkspaceTab } from 'state/selectors/common/temp';
import { isForBooking } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  hasBookingSkippedWarning: boolean;
  isForBooking: boolean;
  solvingMode: string;
  isMultipleSolvingMode: boolean;
  solveResult?: number;
  solveResultFormat?: SolveResultFormat;
  priceInPercent?: number;
  priceInCurrency?: number;
  currency?: string;
  flowWay: FlowWay;
}

export type TradeDoneState = StateProps & OwnProps;

export const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const { bookingSkipped } = getTradeInfosByWorkspaceTab(state, workspaceType, tabId);
  const quoteId = getFormQuoteId(state, workspaceType, tabId);
  const solvingMode = getQuoteSolvingMode(state, tabId);
  const quoteDetails = getFormQuoteDetails(state, workspaceType, tabId);
  const quoteResult = getFormQuoteResult(state, workspaceType, tabId);
  const priceInPercent = getQuotePriceInPercent(state, tabId);
  const priceInCurrency = getQuotePriceInCurrency(state, workspaceType, tabId);
  const currency = getQuoteCurrency(state, workspaceType, tabId);

  const remunerationMode = getQuoteRemunerationMode(state, tabId);
  const tradeWay = getSidePanelTradeWayOrDefault(state, tabId);
  const pricerToBookingInvertedFlow = getQuotePricerToBookingInvertedFlow(state, workspaceType, tabId);
  const cashFlowWay = getCashFlowWay(priceInPercent, remunerationMode, tradeWay, pricerToBookingInvertedFlow);

  const solveResult = quoteResult?.solveResult;
  const solveResultFormat = quoteResult?.solveResultFormat;

  return {
    hasBookingSkippedWarning: bookingSkipped ?? false,
    isForBooking: isForBooking(state, quoteId) ?? false,
    solvingMode,
    isMultipleSolvingMode: quoteDetails?.IsMultipleSolvingMode ?? false,
    solveResult,
    solveResultFormat,
    priceInPercent,
    priceInCurrency,
    currency,
    flowWay: cashFlowWay,
  };
};

export const connectTradeDone = connect(mapStateToProps);
